import { AUTH0_SETTINGS, SALES_REPORT_ENDPOINT } from "./settings.prod.js";

import { ServerInterface } from "./server-interface.js";
import { Auth0Client, createAuth0Client } from "@auth0/auth0-spa-js";

function parseJwt(token: string) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

interface SalesReportWebToken {
    permissions: string[];
}

class Session {
    public API!: ServerInterface;
    public AUTH0!: Auth0Client;
    public JWT!: string;
    public TOKEN!: Promise<SalesReportWebToken>;

    private initPromise: Promise<Session>;

    constructor() {
        this.initPromise = this.initialize();
    }

    public async initialize(): Promise<Session> {
        // 1. Sync init
        let tokenResolve: (token: SalesReportWebToken) => void;
        this.TOKEN = new Promise<SalesReportWebToken>((resolve) => {
            tokenResolve = resolve;
        })

        // 2. Async init (parallel or chained)
        const [auth0Client] = await Promise.all([
            createAuth0Client(AUTH0_SETTINGS),
            // Add other promises here if they can run in parallel
        ]);

        this.AUTH0 = auth0Client;

        if (await app.AUTH0.isAuthenticated()) {
            this.JWT = await auth0Client.getTokenSilently();
            tokenResolve(parseJwt(this.JWT) as SalesReportWebToken);

            // 3. Dependent async calls (e.g., once you have Auth0)
            this.API = new ServerInterface(SALES_REPORT_ENDPOINT, this.JWT);
        }
        else {
            tokenResolve({ permissions: [] } as SalesReportWebToken);
        }


        return this;
    }

    public onInit(): Promise<Session> {
        return this.initPromise;
    }
}

export const app = new Session();
